let expandedNodeIds: string[] | null = null;

export const getStoredExpanded = (): string[] | null => expandedNodeIds;

export const setStoredExpanded = (nodeIds: string[]): void => {
  expandedNodeIds = nodeIds;
};

export const resetStoredExpanded = (): void => {
  expandedNodeIds = null;
};
